import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Form,
  Col,
  Container,
  Image,
  ListGroup,
  Row,
  Nav,
  Spinner,
} from "react-bootstrap";
import { Icon } from "@iconify/react";
import BreadcrumbSection from "components/BreadcrumbSection";
import IMAGES from "constants/images";
import { Link, useNavigate } from "react-router-dom";
import CommonModal from "components/CommonModal";
import TextInput from "components/TextInput";
import VendorSidebar from "inc/VendorSidebar";
import {
  getIndustriesList,
  getCompanySizesList,
  getMyProfileDetails,
  updateProfile,
  fileUpload,
  getRegionsList,
} from "api/authService";
import { toast } from "react-toastify";
import { useAuth } from "context/UserContext";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { useFetchProfile } from "hooks/useFetchProfile";
import ChangePasswordModal from "pages/profile/myprofile/ChangePasswordModal";
import { Sentry } from "react-activity";
import FollowFollowing from "pages/profile/myprofile/FollowFollowing";
import RHFCKEditor from "components/CKEditor";
import Loader from "components/Loader";
const schema = yup.object().shape({
  firstName: yup
    .string()
    .trim()
    .required("First Name is required")
    .min(2, "First Name must be at least 2 characters")
    .max(30, "First Name cannot exceed 30 characters"),
  lastName: yup
    .string()
    .trim()
    .required("Last Name is required")
    .min(2, "Last Name must be at least 2 characters")
    .max(30, "Last Name cannot exceed 30 characters"),
  email: yup.string().email("Invalid email").required("Email is required"),
  region: yup.string(),
  title: yup.string().trim(),
  companyName: yup
    .string()
    .trim()
    .required("Company Name is required")
    .min(2, "Company Name must be at least 2 characters")
    .max(30, "Company name cannot exceed 30 characters"),
  companyEmail: yup
    .string()
    .email("Invalid email")
    .required("Company Email is required"),
  industry: yup.string().required("Industry is required"),
  companySize: yup.string().required("Company Size is required"),
  yearFounded: yup.string().required("Year Founded is required"),
  hqLocation: yup.string().required("HQ Location is required"),
  linkedInProfileUrl: yup
    .string()
    .url("Please enter a valid URL")
    .nullable(),
  twitterProfileUrl: yup
    .string()
    .url("Please enter a valid URL")
    .nullable(),
  companyWebsiteUrl: yup
    .string()
    .url("Please enter a valid URL")
    .nullable(),
  description: yup
    .string()
    .trim()
    .max(500, "Description cannot exceed 500 characters")
    .nullable(),

  companyDescription: yup.string().nullable(),

  companyLogo: yup.string().nullable(),
});

const ProfileDetails = () => {
  const fetchCalledRef = useRef(false);
  const [industries, setIndustries] = useState([]);

  const [companySizes, setCompanySizes] = useState([]);
  const [regions, setRegions] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const [imagePreviewCompany, setImagePreviewCompany] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [updateLoading, setUpdateLoading] = useState(false);
  const { login: loginUser, user } = useAuth();
  const navigate = useNavigate();
  // const [activeTab1, setActiveTab1] = useState("Followers");
  const [showFollowers, setShowFollowers] = useState(false);
  const [followTab, setFollowTab] = useState("Followers");
  const { profile, loading, refetchProfile } = useFetchProfile();
  const [uiLoading, setUiLoading] = useState(true);
  // const [currentUser,setCurrentUser]=useState(null)
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [password, setPassword] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const {
    handleSubmit,
    register,
    control,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const fetchData = async () => {
    try {
      const [industriesRes, companySizesRes, regionsRes] = await Promise.all([
        getIndustriesList(),
        getCompanySizesList(),
        getRegionsList(),
      ]);

      // const profileRes = await getMyProfileDetails();

      setIndustries(industriesRes.body.data);
      setCompanySizes(companySizesRes.body.data);
      setRegions(regionsRes.body.data);
      // const profile = profileRes.body;
      // setCurrentUser(profile)
      // set default values
    } catch (err) {
      console.error("Error loading profile form:", err);
    }
  };

  useEffect(() => {
    if (!fetchCalledRef.current && !profile) {
      fetchCalledRef.current = true;
      fetchData();
    }
  }, [profile]);

  useEffect(() => {
    if (profile) {
      const findIndustry = industries.find((v) => v._id === profile.industry);
      const findComanySize = companySizes?.find(
        (v) => v._id === profile.companySize
      );
      const findRegion = regions.find((v) => v._id === profile.region);

      setValue("firstName", profile?.firstName);
      setValue("lastName", profile?.lastName);
      setValue("email", profile?.email);
      setValue("region", findRegion?.title || "");
      setValue("title", profile?.title || "");
      setValue("companyName", profile?.companyName || "");
      setValue("companyEmail", profile?.companyEmail || "");
      setValue("industry", findIndustry?.title || "");
      setValue("companySize", findComanySize?.title || "");
      setValue("yearFounded", profile?.yearFounded || "");
      setValue("hqLocation", profile?.hqLocation || "");
      setValue("linkedInProfileUrl", profile?.linkedInProfileUrl || "");
      setValue("twitterProfileUrl", profile?.twitterProfileUrl || "");
      setValue("companyWebsiteUrl", profile?.companyWebsiteUrl || "");
      setValue("description", profile?.description || "");
      setValue("companyDescription", profile?.companyDescription || "");
      setImagePreview(profile?.profileUrl || IMAGES.User2_Img);
      setImagePreviewCompany(profile?.companyLogo);
      setValue("companyLogo", profile?.companyLogo);
      setUiLoading(false);
    }
  }, [profile, industries, companySizes, regions]);
  console.log("imageFile-uploaded", imageFile);
  const handleImageChange = (e, type) => {
    const file = e.target.files[0];
    if (!file.type.startsWith("image/")) {
      toast.error("Please select a valid image file.");
      return;
    }

    e.target.value = null;
    if (type === "profile") {
      setImageFile({ profile: file });

      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => setImagePreview(reader.result);
        reader.readAsDataURL(file);
      }
    } else if (type === "company") {
      if (file) {
        setImageFile({ company: file });
        setValue("companyLogo", file);
        const reader = new FileReader();
        reader.onloadend = () => setImagePreviewCompany(reader.result);
        reader.readAsDataURL(file);
      }
    }
    clearErrors("companyLogo");
  };

  const handleCloseModal = () => {
    setShowPasswordModal(false);
  };

  const onSubmit = async (data) => {
    try {
      setUpdateLoading(true);
      let uploadedImageUrl = null;
      let uploadedImageUrlCompany = null;

      if (imageFile && imageFile.profile) {
        const res = await fileUpload(imageFile.profile);
        console.log("uploadedImageUrl", res);
        uploadedImageUrl = res.body[0];
      }
      if (imageFile && imageFile.company) {
        const res = await fileUpload(imageFile.company);
        console.log("uploadedImageUrl", res);
        uploadedImageUrlCompany = res.body[0];
      }

      const findIndustry = industries.find((v) => v.title === data.industry);
      const findComanySize = companySizes?.find(
        (v) => v.title === data.companySize
      );
      const findRegion = regions.find((v) => v.title === data.region);
      const payload = {
        ...data,
        profileUrl: uploadedImageUrl || imagePreview,
        companyLogo: uploadedImageUrlCompany || imagePreviewCompany,
        industry: findIndustry?._id || null,
        companySize: findComanySize?._id || null,
        region: findRegion?._id || null,
      };

      const response = await updateProfile(payload);
      if (response.success === true && response.code === 200) {
        const token = localStorage.getItem("authToken");
        loginUser(response.body, token); // store in context
        toast.success(response.message);
        refetchProfile();
      }
      setUpdateLoading(false);
      //   onEdit(); // close modal or show toast
    } catch (err) {
      setUpdateLoading(false);
      toast.error("Failed to load profile data");
      console.error("Update failed", err);
    }
  };

  // Followers List
  const [followers, setFollowers] = useState([
    {
      id: 1,
      name: "Amelia Zajac",
      followers: "1.2k",
      image: IMAGES.User1_IMG,
    },
    {
      id: 2,
      name: "Juan Rodríguez",
      followers: "1.2k",
      image: IMAGES.User2_Img,
    },
    {
      id: 3,
      name: "Emmanuel Pérez",
      followers: "1.2k",
      image: IMAGES.User3_Img,
    },
    {
      id: 4,
      name: "Amelia Zajac",
      followers: "1.2k",
      image: IMAGES.User1_IMG,
    },
    {
      id: 5,
      name: "Juan Rodríguez",
      followers: "1.2k",
      image: IMAGES.User2_Img,
    },
    {
      id: 6,
      name: "Emmanuel Pérez",
      followers: "1.2k",
      image: IMAGES.User3_Img,
    },
    {
      id: 7,
      name: "Juan Rodríguez",
      followers: "1.2k",
      image: IMAGES.User2_Img,
    },
  ]);

  // Following List
  const [following, setFollowing] = useState([
    {
      id: 1,
      name: "Sara Adébáyọ̀",
      followers: "1.2k",
      image: IMAGES.User2_Img,
    },
    {
      id: 2,
      name: "Slack",
      followers: "1.2k",
      image: IMAGES.Follow1_IMG,
    },
    {
      id: 3,
      name: "Hugo Silva",
      followers: "1.2k",
      image: IMAGES.Follow2_IMG,
    },
    {
      id: 4,
      name: "Sara Adébáyọ̀",
      followers: "1.2k",
      image: IMAGES.User2_Img,
    },
    {
      id: 5,
      name: "Slack",
      followers: "1.2k",
      image: IMAGES.Follow1_IMG,
    },
    {
      id: 6,
      name: "Hugo Silva",
      followers: "1.2k",
      image: IMAGES.Follow2_IMG,
    },
  ]);
  const handleRemove = (id) => {
    setFollowers(followers.filter((user) => user.id !== id));
    setFollowing(following.filter((user) => user.id !== id));
  };

  if (uiLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center "
        style={{ minHeight: "50vh" }}
      >
        <Sentry color="#e91515" size={40} speed={1} animating={true} />
        {/* <Loader  style={{width: 100, height: 100}} /> */}
      </div>
    );
  }

  return (
    <Col lg={12} xl={12}>
      <div className="profile_details_style header_profile3">
        <h3>Profile Details</h3>
      </div>
      <div className="d-flex align-items-center header_profile2 ">
        <Icon icon="mdi:arrow-left" style={{fontSize: "24px"}} className="me-4" onClick={() => navigate("/")}/>
        <h3 className="mb-0">Profile Details</h3>
      </div>
      <h5 className="mt-4">Personal Details</h5>
      <div className="profile_IMG">
        <Image src={imagePreview} className="profile_style" roundedCircle />
        <Form.Label className="edit_IMG">
          <input
            type="file"
            accept="image/*"
            hidden
            onChange={(e) => handleImageChange(e, "profile")}
          />
          <Image src={IMAGES.Edit_Img} />
        </Form.Label>
      </div>
      <Form className="mt-3" onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col md={6}>
            <Form.Group>
              <Form.Label>First Name</Form.Label>
              <Form.Control
                {...register("firstName")}
                placeholder="Enter First Name"
                isInvalid={!!errors?.firstName}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.firstName?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                {...register("lastName")}
                placeholder="Enter Last Name"
                isInvalid={!!errors?.lastName}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.lastName?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Email</Form.Label>
              <Form.Control
                {...register("email")}
                placeholder="Enter Email"
                isInvalid={!!errors?.email}
                disabled
              />
              <Form.Control.Feedback type="invalid">
                {errors?.email?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Region</Form.Label>
              <Form.Select
                {...register("region")}
                isInvalid={!!errors?.region}
                placeholder="Select Region"
              >
                <option value="">Select Region</option>
                {regions?.map((i) => (
                  <option key={i._id} value={i.title}>
                    {i.title}
                  </option>
                ))}
                {/* <option value="">Select Region</option>
                                <option value="USA">USA</option>
                                <option value="Canada">Canada</option>
                                <option value="UK">UK</option>
                                <option value="Australia">Australia</option> */}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors?.region?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>

        <div className="mt-3">
          <TextInput
            labelText="Description"
            placeholder="Enter Description"
            textarea="textarea"
            rows={4}
            {...register("description")}
            errorMessage={errors?.description?.message}
          />
        </div>

        {/* Professional Details */}
        <h5 className="mt-4">Company Details</h5>
        <div className="profile_IMG mb-3">
          {imagePreviewCompany ? (
            <Image
              src={imagePreviewCompany}
              className="profile_style"
              roundedCircle
              alt="company-logo"
            />
          ) : (
            <div
              className="profile_style d-flex align-items-center justify-content-center bg-secondary text-white"
              style={{
                borderRadius: "50%",
                textAlign: "center",
                fontSize: "12px",
                opacity: 0.8,
              }}
            >
              COMPANY LOGO
            </div>
          )}
          <Form.Label className="edit_IMG">
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={(e) => handleImageChange(e, "company")}
            />
            <Image src={IMAGES.Edit_Img} />
          </Form.Label>
        </div>
        {errors?.companyLogo && (
          <p className="text-danger">{errors?.companyLogo?.message}</p>
        )}

        <Row>
          <Col md={6} className="mb-3">
            <Form.Group controlId="companyName">
              <Form.Label>Company Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Company Name"
                {...register("companyName")}
                isInvalid={!!errors?.companyName}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.companyName?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Company Email</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Company Email"
                {...register("companyEmail")}
                isInvalid={!!errors?.companyEmail}
                // disabled
              />
              <Form.Control.Feedback type="invalid">
                {errors?.companyEmail?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Industry</Form.Label>
              <Form.Select
                {...register("industry")}
                placeholder="Select Industry"
                isInvalid={!!errors?.industry}
              >
                <option value="">Select Industry</option>
                {industries.map((i) => (
                  <option key={i._id} value={i.title}>
                    {i.title}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors?.industry?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Company Size</Form.Label>
              <Form.Select
                {...register("companySize")}
                placeholder="Select Size"
                isInvalid={!!errors?.companySize}
              >
                <option value="">Select Size</option>
                {companySizes?.map((s) => (
                  <option key={s?._id} value={s?.title}>
                    {s?.title} Employees
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors?.companySize?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6} className="mb-3">
            <Form.Group controlId="yearFounded">
              <Form.Label>Year Founded</Form.Label>
              <Form.Select
                {...register("yearFounded")}
                placeholder="Select Year"
                isInvalid={!!errors?.yearFounded}
              >
                <option value="">Select Year</option>
                {Array.from({ length: 50 }, (_, i) => {
                  const year = new Date().getFullYear() - i;
                  return (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  );
                })}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors?.yearFounded?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6} className="mb-3">
            <Form.Group controlId="companySize">
              <Form.Label>HQ Location</Form.Label>
              <Form.Select
                {...register("hqLocation")}
                placeholder="Select Location"
                isInvalid={!!errors?.hqLocation}
              >
                <option value="">Select Location</option>
                <option value="Tel Aviv">Tel Aviv</option>
                <option value="Jerusalem">Jerusalem</option>
                <option value="Haifa">Haifa</option>
                <option value="Rishon LeZion">Rishon LeZion</option>
                <option value="Petah Tikva">Petah Tikva</option>
                <option value="Ashdod">Ashdod</option>
                <option value="Netanya">Netanya</option>
                <option value="Beer Sheva">Beer Sheva</option>
                <option value="Holon">Holon</option>
                <option value="Bnei Brak">Bnei Brak</option>
                <option value="Ramat Gan">Ramat Gan</option>
                <option value="Other">Other</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors?.hqLocation?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={12} className="mb-3">
            <Form.Group controlId="description">
              <Form.Label className="mb-2">Company Decription</Form.Label>
              {/* <Form.Control
                as="textarea"
                placeholder="Enter Company Description"
                rows={4}
                {...register("companyDescription")}
                isInvalid={!!errors?.companyDescription}
              /> */}
              <Controller
                name="companyDescription"
                control={control}
                rules={{ required: "Description is required" }}
                render={({ field, fieldState }) => (
                  <RHFCKEditor
                    field={field}
                    fieldState={fieldState}
                    // label="Company Description"
                    placeholder="Enter Company Description here..."
                    // maxHeight={450}
                  />
                )}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.companyDescription?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>

        {/* Social Links */}
        <h5 className="mt-1">Social Links</h5>
        <Row className="social_links_style">
          <Col md={6} className="mb-3">
            <Form.Group controlId="linkedin">
              <Form.Label>LinkedIn Profile URL</Form.Label>
              <Form.Control
                {...register("linkedInProfileUrl")}
                placeholder="Enter LinkedIn Profile URL"
                isInvalid={!!errors?.linkedInProfileUrl}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.linkedInProfileUrl?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6} className="mb-3">
            <Form.Group controlId="twitter">
              <Form.Label>Twitter Profile URL</Form.Label>
              <Form.Control
                {...register("twitterProfileUrl")}
                placeholder="Enter Twitter Profile URL"
                isInvalid={!!errors?.twitterProfileUrl}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.twitterProfileUrl?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6} className="mb-3">
            <Form.Group controlId="companyWebsiteUrl">
              <Form.Label>Company Website URL</Form.Label>
              <Form.Control
                {...register("companyWebsiteUrl")}
                placeholder="Enter Company Website URL"
                isInvalid={!!errors?.companyWebsiteUrl}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.companyWebsiteUrl?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>

        <div className="tab_1link">
          <Link onClick={() => setShowPasswordModal(true)}>
            Looking to change your password?
          </Link>
          <Button
            disabled={updateLoading}
            type="submit"
            variant="info"
            className="border-radius-100"
            style={{ maxWidth: "250px" }}
          >
            {updateLoading ? <Spinner animation="border" size="sm" /> : "Save"}
          </Button>
        </div>
      </Form>
      <ChangePasswordModal
        show={showPasswordModal}
        onClose={handleCloseModal}
      />
    </Col>
  );
};

export default ProfileDetails;
